// ============================================================
// globalecomponent.scss.ts
// Styles regroupés par COMPOSANT (components/**/*.css)
// Toutes les règles provenant des fichiers de composants
// ============================================================

export const globaleComponentStyles = `
// ============================================================
// GLOBALECOMPONENT.SCSS — Styles regroupés par COMPOSANT
// Tous les composants de l'application
// ============================================================

// ═══════════════════════════════════════════════════════════
// COMPOSANT : RECAP ACTIVITIES (recapactivities.component.css)
// ═══════════════════════════════════════════════════════════

:host {
  display: block;
}

.recap-card {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.recap-section {
  background: var(--colorWhite);
  border: 1px solid var(--colorBorder);
  border-radius: var(--radius2Xl);
  padding: 20px 24px;
  box-shadow: var(--shadowSm);
  transition: box-shadow 200ms ease;
}

.recap-section:hover {
  box-shadow: var(--shadowLg);
}

.recap-section--pmp {
  border-color: var(--colorVioletLight);
  background: linear-gradient(135deg, var(--colorVioletSurface) 0%, var(--colorWhite) 60%);
}

.recap-section__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--colorNeutral100);
}

.recap-section__icon {
  font-size: 20px;
  color: var(--btnSelectedBg);
}

.recap-section__title {
  font-size: 0.95rem;
  font-weight: var(--fontWeightBold);
  color: var(--colorNeutral900);
  margin: 0;
  flex: 1;
}

.pmp-badge {
  font-size: 0.68rem;
  font-weight: var(--fontWeightBold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--colorViolet);
  background: var(--colorVioletSurface);
  border: 1px solid var(--colorVioletLight);
  border-radius: 20px;
  padding: 2px 10px;
}

.recap-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
}

@media (max-width: 640px) {
  .recap-grid {
    grid-template-columns: 1fr;
  }
}

.recap-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.recap-item--full {
  grid-column: 1 / -1;
}

.recap-item__label {
  font-size: 0.73rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorGray400);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.recap-item__value {
  font-size: 0.9rem;
  color: var(--colorNeutral800);
  font-weight: 500;
  line-height: 1.4;
}

.recap-item__value--money {
  font-variant-numeric: tabular-nums;
  color: var(--colorAccentDark);
  font-weight: var(--fontWeightSemibold);
}

.recap-item__value--date {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--btnSelectedBg);
  font-weight: var(--fontWeightSemibold);
}

.recap-item__date-icon {
  font-size: 14px;
  opacity: 0.8;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.tag {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--colorGray600);
  background: var(--colorNeutral100);
  border: 1px solid var(--colorBorder);
  border-radius: 20px;
  padding: 3px 10px;
}

.taches-block {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px dashed var(--colorBorder);
}

.taches-block__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorNeutral700);
  margin: 0 0 12px;
}

.taches-block__title .material-icons {
  font-size: 18px;
  color: var(--btnSelectedBg);
}

.taches-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tache-item {
  background: var(--colorNeutral100);
  border: 1px solid var(--colorBorder);
  border-radius: var(--radiusMd);
  padding: 10px 14px;
}

.tache-item__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.tache-item__num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--btnSelectedBg);
  color: var(--colorWhite);
  font-size: 0.7rem;
  font-weight: var(--fontWeightBold);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tache-item__title {
  font-size: 0.875rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorNeutral800);
  flex: 1;
}

.tache-item__poids {
  font-size: 0.75rem;
  color: var(--colorGray500);
  background: var(--colorBorder);
  border-radius: 20px;
  padding: 2px 8px;
}

.tache-item__months {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.month-badge {
  font-size: 0.72rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorPrimary600);
  background: var(--colorPrimaryLight2);
  border-radius: 20px;
  padding: 2px 8px;
}

.recap-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding-top: 8px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
  font-weight: var(--fontWeightSemibold);
  cursor: pointer;
  border-radius: var(--radiusMd);
  transition: all 160ms ease;
  white-space: nowrap;
  text-decoration: none;
  outline: none;
}

.btn-md {
  padding: 10px 20px;
  font-size: 0.875rem;
}

.btn-primary {
  background: var(--btnSelectedBg);
  color: var(--colorWhite);
  border: 1px solid transparent;
  box-shadow: var(--shadowBtn);
}

.btn-primary:hover:not(:disabled) {
  background: color-mix(in srgb, var(--btnSelectedBg) 88%, black);
  box-shadow: var(--shadowAccent);
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 1;
  cursor: not-allowed;
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-secondary {
  background: var(--colorNeutral100);
  color: var(--colorGray600);
  border: 1px solid var(--colorBorder);
  box-shadow: var(--shadowSm);
}

.btn-secondary:hover {
  background: var(--colorNeutral100);
  border-color: var(--colorGray300);
  color: var(--colorNeutral800);
  transform: translateY(-1px);
}

.btn-secondary:active {
  transform: translateY(0);
}

.btn-icon {
  font-size: 18px;
  line-height: 1;
}

.btn-icon--left {
  margin-right: 2px;
}

.btn-icon--right {
  margin-left: 2px;
}

.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: var(--colorWhite);
  border-radius: 50%;
  animation: spin 600ms linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.recap-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 48px 24px;
  text-align: center;
  background: var(--colorWhite);
  border: 1px dashed var(--colorBorder);
  border-radius: var(--radius2Xl);
}

.recap-empty__icon {
  font-size: 48px;
  color: var(--colorGray300);
}

.recap-empty__text {
  font-size: 1rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorNeutral700);
  margin: 0;
}

.recap-empty__sub {
  font-size: 0.875rem;
  color: var(--colorGray400);
  margin: 0 0 8px;
}

@media (max-width: 640px) {
  .recap-section {
    padding: 16px;
  }
  .recap-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .btn {
    width: 100%;
    justify-content: center;
  }
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : STEP ACTIVITIES (stepfouractivities, steponeactivities, stepthreeactivities, steptwoactivities)
// ═══════════════════════════════════════════════════════════

:host {
  display: block;
}

.step-card {
  max-width: 900px;
  margin: 0 auto;
  padding: 28px 32px;
  background: var(--colorWhite);
  border-radius: var(--radius2Xl);
  box-shadow: var(--shadowLg);
  position: relative;
}

.step-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  flex: 1 1 0;
  min-width: 0;
}

.field-error {
  display: block;
  color: var(--colorDangerDark);
  font-size: 0.78rem;
  margin-top: 5px;
  padding-left: 2px;
}

@media (min-width: 768px) {
  .form-row {
    flex-direction: row;
    align-items: flex-start;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding-top: 8px;
  border-top: 1px solid var(--colorNeutral100);
  margin-top: 4px;
}

.btn-danger {
  background: var(--colorDanger);
  color: var(--colorWhite);
  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.25);
}

.btn-danger:hover {
  background: color-mix(in srgb, var(--colorDanger) 88%, black);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.35);
  transform: translateY(-1px);
}

.btn-danger:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.2);
}

.alert-card {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 300px;
  background: var(--colorDangerSoft);
  border: 1px solid var(--colorDangerRing);
  color: var(--colorDanger800);
  padding: 14px 16px;
  border-radius: var(--radiusLg);
  box-shadow: var(--shadow2Xl);
  z-index: 40;
  animation: alert-slide-in 180ms ease;
}

@keyframes alert-slide-in {
  from { opacity: 0; transform: translateY(-6px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.alert-title {
  font-weight: var(--fontWeightBold);
  margin-bottom: 6px;
  font-size: 0.875rem;
}

.alert-body {
  font-size: 0.82rem;
  line-height: 1.5;
}

.alert-body ul {
  margin: 6px 0 0 16px;
  padding: 0;
}

.alert-close {
  position: absolute;
  top: 8px;
  right: 10px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  opacity: 0.6;
  transition: opacity 120ms;
}

.alert-close:hover {
  opacity: 1;
}

@media (max-width: 640px) {
  .step-card {
    padding: 20px 16px;
    border-radius: var(--radiusLg);
  }
  .actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .btn {
    width: 100%;
    justify-content: center;
  }
  .alert-card {
    right: 8px;
    left: 8px;
    top: 8px;
    width: auto;
  }
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : BUTTON (button.component.scss)
// ═══════════════════════════════════════════════════════════

:host {
  --btn-accent: var(--colorAccentVariant);
  --btn-accent-dark: var(--colorAccentVariantDark);
  --btn-accent-light: var(--colorPrimaryLight);
  --btn-danger: var(--colorDanger);
  --btn-danger-dark: var(--colorDangerDark);
  --btn-success: var(--colorSuccess);
  --btn-success-dark: var(--colorSuccessDark);
  --btn-radius: var(--radiusMd);
  --btn-font: var(--fontFamily);
  --btn-transition: var(--transitionSlow);

  display: inline-flex;
}

:host(.full-width) {
  width: 100%;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: var(--btn-font);
  font-weight: 500;
  letter-spacing: 0.012em;
  border: 1.5px solid transparent;
  border-radius: var(--btn-radius);
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  user-select: none;
  position: relative;
  overflow: hidden;
  transition: background var(--btn-transition), border-color var(--btn-transition), box-shadow var(--btn-transition), transform var(--btn-transition), opacity 0.15s ease;
}

.btn::after {
  content: "";
  position: absolute;
  inset: 0;
  background: transparent;
  border-radius: inherit;
  transition: background 0.12s ease;
  pointer-events: none;
}

.btn:active:not(:disabled)::after {
  background: rgba(0, 0, 0, 0.07);
}

.btn:focus-visible {
  outline: 2.5px solid var(--btn-accent);
  outline-offset: 2px;
}

.btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}

.btn-full {
  width: 100%;
}

.btn-xs {
  padding: 4px 10px;
  font-size: 0.75rem;
  border-radius: var(--radiusSm);
  gap: 4px;
}

.btn-xs .btn-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.btn-sm {
  padding: 6px 14px;
  font-size: 0.8125rem;
  border-radius: var(--radiusSm);
  gap: 5px;
}

.btn-sm .btn-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.btn-md {
  padding: 9px 18px;
  font-size: 0.875rem;
}

.btn-md .btn-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.btn-lg {
  padding: 12px 24px;
  font-size: 0.9375rem;
  border-radius: var(--radiusLg);
}

.btn-lg .btn-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.btn-icon-only {
  padding: 0;
  aspect-ratio: 1;
}

.btn-icon-only.btn-xs {
  width: 28px;
}

.btn-icon-only.btn-sm {
  width: 34px;
}

.btn-icon-only.btn-md {
  width: 40px;
}

.btn-icon-only.btn-lg {
  width: 48px;
}

.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: inherit;
  line-height: 1;
  vertical-align: middle;
}

.btn-primary {
  background: var(--btn-accent);
  color: var(--colorWhite);
  border-color: var(--btn-accent);
  box-shadow: 0 1px 2px rgba(91, 79, 255, 0.2), 0 3px 10px rgba(91, 79, 255, 0.25);
}

.btn-primary:hover:not(:disabled) {
  background: var(--btn-accent-dark);
  border-color: var(--btn-accent-dark);
  box-shadow: 0 2px 4px rgba(91, 79, 255, 0.2), 0 6px 18px rgba(91, 79, 255, 0.35);
  transform: translateY(-1px);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(91, 79, 255, 0.2);
}

.btn-primary .spinner {
  border-color: rgba(255, 255, 255, 0.35);
  border-top-color: var(--colorWhite);
}

.btn-secondary {
  background: var(--colorWhite);
  color: var(--colorTextPrimary);
  border-color: var(--colorBorderStrong);
  box-shadow: 0 1px 2px rgba(14, 14, 18, 0.05);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--colorSurfaceAlt2);
  border-color: #b5b5cc;
  box-shadow: 0 2px 8px rgba(14, 14, 18, 0.08);
  transform: translateY(-1px);
}

.btn-secondary:active:not(:disabled) {
  transform: translateY(0);
  background: #f3f3f8;
}

.btn-secondary .spinner {
  border-color: rgba(14, 14, 18, 0.18);
  border-top-color: var(--btn-accent);
}

.btn-danger {
  background: var(--btn-danger);
  color: var(--colorWhite);
  border-color: var(--btn-danger);
  box-shadow: 0 1px 2px rgba(226, 63, 63, 0.2), 0 3px 10px rgba(226, 63, 63, 0.2);
}

.btn-danger:hover:not(:disabled) {
  background: var(--btn-danger-dark);
  border-color: var(--btn-danger-dark);
  box-shadow: 0 2px 4px rgba(226, 63, 63, 0.2), 0 6px 18px rgba(226, 63, 63, 0.3);
  transform: translateY(-1px);
}

.btn-danger:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(226, 63, 63, 0.2);
}

.btn-outline {
  background: transparent;
  color: var(--btn-accent);
  border-color: var(--btn-accent);
}

.btn-outline:hover:not(:disabled) {
  background: var(--btn-accent-light);
  transform: translateY(-1px);
}

.btn-outline:active:not(:disabled) {
  transform: translateY(0);
  background: rgba(91, 79, 255, 0.12);
}

.btn-ghost {
  background: transparent;
  color: #4a4a6a;
  border-color: transparent;
}

.btn-ghost:hover:not(:disabled) {
  background: rgba(14, 14, 18, 0.05);
  color: var(--colorTextPrimary);
}

.btn-ghost:active:not(:disabled) {
  background: rgba(14, 14, 18, 0.09);
}

.btn-success {
  background: var(--btn-success);
  color: var(--colorWhite);
  border-color: var(--btn-success);
  box-shadow: 0 1px 2px rgba(24, 160, 107, 0.2), 0 3px 10px rgba(24, 160, 107, 0.2);
}

.btn-success:hover:not(:disabled) {
  background: var(--btn-success-dark);
  border-color: var(--btn-success-dark);
  box-shadow: 0 2px 4px rgba(24, 160, 107, 0.2), 0 6px 18px rgba(24, 160, 107, 0.3);
  transform: translateY(-1px);
}

.btn-success:active:not(:disabled) {
  transform: translateY(0);
}

.spinner {
  display: inline-block;
  flex-shrink: 0;
  width: 15px;
  height: 15px;
  border: 2px solid transparent;
  border-radius: 50%;
  animation: btn-spin 0.6s linear infinite;
}

.btn-xs .spinner {
  width: 11px;
  height: 11px;
}

.btn-sm .spinner {
  width: 13px;
  height: 13px;
}

.btn-lg .spinner {
  width: 17px;
  height: 17px;
}

@keyframes btn-spin {
  to { transform: rotate(360deg); }
}

.btn-label {
  display: inline-flex;
  align-items: center;
  line-height: 1.2;
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : PROFILE MENU (profilemenu.component.scss)
// ═══════════════════════════════════════════════════════════

:host {
  --dp-surface: var(--colorWhite);
  --dp-surface-alt: var(--colorSurfaceAlt);
  --dp-border: rgba(15, 15, 15, 0.08);
  --dp-border-lg: rgba(15, 15, 15, 0.14);
  --dp-text: #0f0f0f;
  --dp-muted: #6b6b6b;
  --dp-icon: var(--colorGray400);
  --dp-icon-bg: var(--colorGray100);
  --dp-accent: var(--colorTextPrimary);
  --dp-online: #22c55e;
  --dp-danger: var(--colorDanger700);
  --dp-danger-bg: var(--colorDangerSurface);
  --dp-shadow: var(--shadowXl);
  --dp-radius: var(--radius2Xl);
  --dp-radius-sm: var(--radiusMd);
  --dp-font: inherit;
  display: block;
  position: relative;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--colorTextPrimary) 0%, #4a4e8c 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: inset 0 1px 2px rgba(255,255,255,0.15), 0 0 0 2px rgba(255,255,255,0.9), 0 0 0 3px rgba(15,15,15,0.10);
}

.avatar--lg {
  width: 40px;
  height: 40px;
}

.avatar--lg .avatar-initials {
  font-size: 0.85rem;
}

.avatar-initials {
  font-size: 0.72rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorWhite);
  letter-spacing: 0.04em;
  line-height: 1;
}

.role-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--dp-online);
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
}

.profile-toggle {
  background: transparent;
  border: 1px solid var(--dp-border-lg);
  border-radius: var(--radiusLg);
  padding: 5px 10px 5px 6px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  font-family: var(--dp-font);
  transition: background 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;
}

.profile-toggle:hover {
  background: var(--dp-surface-alt);
  border-color: rgba(15,15,15,0.2);
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.profile-toggle.active {
  background: var(--dp-surface-alt);
  border-color: rgba(15,15,15,0.2);
}

.profile-info {
  display: none;
  flex-direction: column;
  text-align: left;
  line-height: 1.25;
}

@media (min-width: 1024px) {
  .profile-info {
    display: flex;
  }
}

.profile-name {
  font-size: 0.82rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--dp-text);
  letter-spacing: -0.01em;
}

.profile-role {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  color: var(--dp-muted);
  margin-top: 2px;
}

.chevron {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  color: var(--dp-icon);
  transition: transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.profile-toggle.active .chevron {
  transform: rotate(180deg);
}

.dropdown-box {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  width: 248px;
  background: var(--dp-surface);
  border: 1px solid var(--dp-border);
  border-radius: var(--dp-radius);
  box-shadow: var(--dp-shadow);
  z-index: 1200;
  overflow: hidden;
  transform-origin: top right;
  animation: dropIn 0.18s cubic-bezier(0.22, 0.68, 0, 1.2) both;
}

@keyframes dropIn {
  from { opacity: 0; transform: scale(0.96) translateY(-6px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.dropdown-header {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 14px 14px 12px;
  background: var(--dp-surface-alt);
  border-bottom: 1px solid var(--dp-border);
}

.dropdown-header-info {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  min-width: 0;
}

.dropdown-header-name {
  font-size: 0.83rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--dp-text);
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-header-role {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  color: var(--dp-muted);
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-body {
  padding: 6px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  font-size: 0.82rem;
  font-weight: 450;
  color: var(--dp-text);
  text-decoration: none;
  border-radius: var(--dp-radius-sm);
  cursor: pointer;
  transition: background 0.12s ease;
  width: 100%;
  border: none;
  background: transparent;
  font-family: var(--dp-font);
  letter-spacing: -0.005em;
}

.dropdown-item:hover {
  background: var(--dp-surface-alt);
}

.dropdown-item:hover .item-icon-wrap {
  background: #e8e8f0;
}

.dropdown-item:hover .item-icon-wrap .item-icon {
  color: var(--dp-accent);
}

.dropdown-item:hover .item-arrow {
  opacity: 1;
  transform: translateX(2px);
}

.item-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: var(--radiusSm);
  background: var(--dp-icon-bg);
  flex-shrink: 0;
  transition: background 0.12s ease;
}

.item-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  color: var(--dp-muted);
  transition: color 0.12s ease;
  display: flex;
  align-items: center;
}

.item-label {
  flex: 1;
}

.item-badge {
  margin-left: auto;
  background: var(--dp-accent);
  color: var(--colorWhite);
  font-size: 0.63rem;
  font-weight: var(--fontWeightSemibold);
  padding: 2px 7px;
  border-radius: 20px;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.item-arrow {
  font-size: 14px !important;
  width: 14px !important;
  height: 14px !important;
  color: var(--dp-icon);
  opacity: 0;
  transition: opacity 0.12s ease, transform 0.15s ease;
  margin-left: -4px;
}

.dropdown-footer {
  padding: 6px;
  border-top: 1px solid var(--dp-border);
}

.btn-logout-wrap {
  width: 100%;
}

.btn-logout-wrap ::ng-deep .btn.btn-ghost {
  width: 100%;
  justify-content: flex-start;
  padding: 8px 10px;
  border-radius: var(--dp-radius-sm);
  color: var(--dp-danger) !important;
  font-size: 0.82rem;
  font-weight: 500;
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
  gap: 9px;
  transition: background 0.15s ease, border-color 0.15s ease !important;
}

.btn-logout-wrap ::ng-deep .btn.btn-ghost .btn-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  color: var(--dp-danger) !important;
  opacity: 0.8;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.btn-logout-wrap ::ng-deep .btn.btn-ghost:hover:not(:disabled) {
  background: rgba(192, 57, 43, 0.12) !important;
  border-color: rgba(192, 57, 43, 0.2) !important;
  color: var(--dp-danger) !important;
  transform: none !important;
}

.btn-logout-wrap ::ng-deep .btn.btn-ghost:hover:not(:disabled) .btn-icon {
  opacity: 1 !important;
  transform: translateX(2px);
}

:host-context(.dark) {
  --dp-surface: #1c1c1e;
  --dp-surface-alt: #2c2c2e;
  --dp-border: rgba(255,255,255,0.07);
  --dp-border-lg: rgba(255,255,255,0.12);
  --dp-text: #f2f2f2;
  --dp-muted: #a0a0a5;
  --dp-icon: #6b6b70;
  --dp-icon-bg: rgba(255,255,255,0.06);
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : FORMS (input, select, textarea, button)
// ═══════════════════════════════════════════════════════════

:host {
  display: block;
}

.floating-label {
  display: block;
  font-family: var(--fontFamily);
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--colorBlack);
  letter-spacing: 0.01em;
  margin-bottom: 7px;
}

.floating-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.floating-wrapper.is-textarea {
  align-items: flex-start;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--colorBlack);
  pointer-events: none;
  z-index: 1;
  transition: color 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-icon--textarea {
  top: 13px;
  transform: none;
}

.floating-wrapper:has(.input-root[type="text"]) .input-icon,
.floating-wrapper:has(.input-root[type="search"]) .input-icon {
  color: #060606;
}

.floating-wrapper:has(.input-root[type="number"]) .input-icon {
  color: var(--colorViolet);
}

.floating-wrapper:has(.input-root[type="email"]) .input-icon {
  color: var(--colorInfo);
}

.floating-wrapper:has(.input-root[type="password"]) .input-icon {
  color: var(--colorWarning);
}

.floating-wrapper:has(.input-root[type="tel"]) .input-icon {
  color: var(--colorSuccess);
}

.floating-wrapper:has(.input-root[type="url"]) .input-icon {
  color: var(--colorCyan);
}

.floating-wrapper:has(.input-root[type="date"]) .input-icon {
  color: var(--btnSelectedBg);
}

.floating-wrapper:has(.input-root[type="time"]) .input-icon {
  color: var(--colorWarning600);
}

.floating-wrapper.is-textarea .input-icon {
  color: var(--colorInfo);
}

.input-root {
  appearance: none;
  width: 100%;
  padding: 11px 14px 11px 42px;
  font-family: var(--fontFamily);
  font-size: var(--fontSizeLg);
  font-weight: 400;
  color: #0e0e12;
  background: var(--colorSurface);
  border: 1.5px solid var(--colorBlack);
  border-radius: var(--radiusXl);
  box-shadow: var(--shadowInput);
  transition: border-color 0.22s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.22s cubic-bezier(0.4, 0, 0.2, 1), background 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  box-sizing: border-box;
}

.input-root:hover {
  border-color: var(--colorAccent);
  background: var(--colorWhite);
}

.input-root:focus {
  border-color: var(--colorPrimary);
  background: var(--colorWhite);
  box-shadow: 0 0 0 3px rgba(91, 79, 255, 0.18), 0 1px 3px rgba(14, 14, 18, 0.06);
}

.floating-wrapper:focus-within .input-icon {
  color: var(--colorPrimary);
}

.input-textarea {
  resize: vertical;
  min-height: 96px;
  line-height: 1.6;
  padding-top: 11px;
  padding-bottom: 11px;
  padding-left: 42px;
}

.floating-wrapper.is-textarea:focus-within .input-icon {
  color: var(--colorInfo);
}

.floating-wrapper.is-textarea .input-textarea:focus {
  border-color: var(--colorInfo);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.16), var(--shadowInput);
}

.input-root.input-date {
  background: var(--colorSurfaceSuccess);
  border-color: var(--colorBlack);
  color: var(--colorBlack);
  font-weight: 500;
  font-family: var(--fontFamily);
}

.input-root.input-date:hover {
  background: #f2f7f5;
  border-color: var(--colorAccentLight);
}

.input-root.input-date:focus {
  background: var(--colorWhite);
  border-color: var(--btnSelectedBg);
  color: #0e0e12;
}

.input-root.input-date::-webkit-calendar-picker-indicator {
  opacity: 0;
  position: absolute;
  right: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.input-root.input-date::-moz-calendar-picker-indicator {
  opacity: 0;
}

.input-root.no-icon {
  padding-left: 14px;
}

.input-root.is-error {
  border-color: var(--colorDanger);
  background: var(--colorWhite);
}

.input-root.is-error:focus {
  box-shadow: 0 0 0 3px rgba(226, 63, 63, 0.16), var(--shadowInput);
}

.input-root.is-success {
  border-color: var(--colorSuccess);
  background: var(--colorWhite);
}

.input-root.is-success:focus {
  box-shadow: 0 0 0 3px rgba(14, 165, 90, 0.16), var(--shadowInput);
}

.input-root:disabled {
  background: #f0f0f5;
  color: #8e8ea8;
  cursor: not-allowed;
  border-color: #e4e4ed;
}

.input-state {
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.input-help {
  font-size: 0.78rem;
  color: #efeff7;
  line-height: 1.4;
  margin-top: 5px;
}

.input-help.error {
  color: var(--colorDanger);
}

.input-help.success {
  color: var(--colorSuccess);
}

@media (max-width: 768px) {
  .input-root {
    padding: 10px 12px 10px 38px;
    font-size: 0.9rem;
    border-radius: var(--radiusLg);
  }
  .input-icon {
    left: 11px;
  }
  .input-icon--textarea {
    top: 11px;
  }
}

// ── Select ───────────────────────────────────────────────────

.select-chevron {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #8e8ea8;
  pointer-events: none;
  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1), color 0.18s ease;
}

.select-chevron.is-open {
  transform: translateY(-50%) rotate(180deg);
  color: var(--colorPrimary);
}

.floating-wrapper:focus-within .select-chevron {
  color: var(--colorPrimary);
}

.select-list {
  position: absolute;
  z-index: 99999;
  left: 0;
  right: 0;
  top: 100%;
  background: var(--colorWhite);
  border: 1.5px solid var(--colorPrimary);
  border-top: none;
  border-bottom-left-radius: var(--radiusXl);
  border-bottom-right-radius: var(--radiusXl);
  box-shadow: var(--shadowDropdown);
  max-height: 240px;
  overflow-y: auto;
  padding: 4px;
  margin: 0;
  list-style: none;
  animation: list-enter 0.16s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  scrollbar-width: thin;
  scrollbar-color: #e4e4ed transparent;
}

@keyframes list-enter {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.select-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border-radius: var(--radiusMd);
  cursor: pointer;
  font-family: var(--fontFamily);
  font-size: 0.9rem;
  color: #0e0e12;
  transition: background 0.13s ease, color 0.13s ease;
  user-select: none;
}

.select-option:hover {
  background: var(--colorPrimarySoft);
  color: var(--colorPrimary);
}

.select-option.is-selected {
  color: var(--colorPrimary);
  font-weight: 500;
  background: var(--colorPrimarySurface);
}

.option-check {
  flex-shrink: 0;
  color: var(--colorPrimary);
}

.select-option--empty {
  color: var(--colorTextMuted);
  padding: 12px;
  cursor: default;
  font-size: 0.87rem;
  justify-content: center;
}

.select-option--empty:hover {
  background: transparent;
  color: var(--colorTextMuted);
}

// ── Textarea ──────────────────────────────────────────────────

.textarea-label {
  display: block;
  font-family: var(--fontFamily);
  font-size: 0.82rem;
  font-weight: 500;
  color: #4a4a5a;
  margin-bottom: 7px;
  letter-spacing: 0.01em;
}

.textarea-root {
  display: block;
  width: 100%;
  min-height: 110px;
  max-height: 280px;
  resize: vertical;
  padding: 12px 14px;
  font-family: var(--fontFamily);
  font-size: var(--fontSizeLg);
  font-weight: 400;
  line-height: 1.6;
  color: #0e0e12;
  background: var(--colorSurfaceAlt2);
  border: 1.5px solid #e4e4ed;
  border-radius: var(--radiusXl);
  box-shadow: var(--shadowInput);
  transition: border-color 0.22s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.22s cubic-bezier(0.4, 0, 0.2, 1), background 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
}

.textarea-root::placeholder {
  color: var(--colorTextMuted);
}

.textarea-root:hover {
  border-color: #c8c8da;
  background: var(--colorWhite);
}

.textarea-root:focus {
  border-color: var(--colorPrimary);
  background: var(--colorWhite);
  box-shadow: 0 0 0 3px rgba(91, 79, 255, 0.18), var(--shadowInput);
}

.textarea-root:disabled {
  background: #f0f0f5;
  color: var(--colorTextMuted);
  cursor: not-allowed;
  border-color: #e4e4ed;
  resize: none;
}

.textarea-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 7px;
  gap: 8px;
}

.textarea-help {
  font-size: 0.78rem;
  color: var(--colorTextMuted);
  line-height: 1.4;
  flex: 1;
}

.textarea-counter {
  font-size: 0.76rem;
  color: var(--colorTextMuted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  flex-shrink: 0;
  transition: color 0.22s ease;
}

.textarea-counter.warn {
  color: var(--colorWarning);
}

.textarea-counter.danger {
  color: var(--colorDanger);
}

@media (max-width: 768px) {
  .textarea-root {
    min-height: 90px;
    border-radius: var(--radiusLg);
    font-size: 0.9rem;
  }
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : FORMULAIRE DYNAMIC (formulaire-dynamic.css)
// ═══════════════════════════════════════════════════════════

.fd-form {
  display: block;
  width: 100%;
  background: var(--colorWhite);
  border-radius: var(--radiusXl);
  overflow: hidden;
}

.fd-section {
  margin-bottom: 16px;
  border: 1px solid var(--colorGray200);
  border-radius: var(--radiusLg);
  overflow: hidden;
}

.fd-section-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  background: var(--colorAccentSurface);
  border-bottom: 1px solid var(--colorAccentVariantLight);
}

.fd-section-banner-bar {
  width: 3px;
  height: 18px;
  border-radius: 2px;
  background: var(--colorAccentTeal);
  flex-shrink: 0;
}

.fd-section-title {
  font-size: var(--fontSizeLg);
  font-weight: var(--fontWeightBold);
  color: var(--colorNeutral900);
  margin: 0;
  letter-spacing: -0.1px;
}

.fd-section-body {
  padding: 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fd-grid {
  display: grid;
  gap: 16px;
}

.fd-grid-cols-1 {
  grid-template-columns: 1fr;
}

.fd-grid-md-2 {
  grid-template-columns: repeat(2, 1fr);
}

.fd-grid-md-3 {
  grid-template-columns: repeat(3, 1fr);
}

.fd-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.fd-label {
  font-size: 0.83rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorNeutral700);
  margin: 0;
}

.fd-required {
  color: var(--colorDanger);
  margin-left: 3px;
}

.fd-input,
.fd-textarea {
  width: 100%;
  border: 1px solid var(--colorBorderInput);
  padding: 8px 10px;
  border-radius: var(--radiusMd);
  font-size: 0.9rem;
  background: var(--colorWhite);
  color: var(--colorNeutral900);
  transition: border-color 150ms, box-shadow 150ms;
  outline: none;
  box-sizing: border-box;
}

.fd-input:focus,
.fd-textarea:focus {
  border-color: var(--colorAccentTeal);
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.1);
}

.fd-textarea {
  min-height: 72px;
  resize: vertical;
}

.fd-invalid {
  border-color: var(--colorDangerLight) !important;
  background: var(--colorDangerSoft);
}

.fd-error {
  color: var(--colorDanger500);
  font-size: 0.73rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.fd-error::before {
  content: '⚠';
  font-size: 0.7rem;
}

.fd-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fd-checkbox-label {
  font-size: 0.85rem;
  color: var(--colorNeutral700);
}

.fd-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px 20px;
  border-top: 1px solid var(--colorNeutral100);
}

.fd-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: var(--radiusMd);
  border: 1px solid var(--colorBorderInput);
  background: var(--colorWhite);
  color: var(--colorNeutral700);
  font-size: 0.85rem;
  font-weight: var(--fontWeightSemibold);
  cursor: pointer;
  transition: all 140ms ease;
  white-space: nowrap;
}

.fd-btn-back:hover {
  background: var(--colorNeutral50);
  border-color: var(--colorGray400);
  color: var(--colorNeutral900);
}

.fd-btn-back .fd-btn-icon {
  color: var(--colorGray500);
  transition: transform 140ms ease;
}

.fd-btn-back:hover .fd-btn-icon {
  transform: translateX(-2px);
}

.fd-btn-submit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border-radius: var(--radiusMd);
  border: none;
  background: var(--colorAccentTeal);
  color: var(--colorWhite);
  font-size: 0.85rem;
  font-weight: var(--fontWeightSemibold);
  cursor: pointer;
  transition: all 140ms ease;
  white-space: nowrap;
}

.fd-btn-submit:hover:not(:disabled) {
  background: var(--colorAccentTealDark);
  transform: translateY(-1px);
  box-shadow: var(--shadowTeal);
}

.fd-btn-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.fd-spin {
  display: inline-block;
  animation: fd-rotate 1s linear infinite;
}

@keyframes fd-rotate {
  to { transform: rotate(360deg); }
}

@media (max-width: 640px) {
  .fd-section-body {
    padding: 14px 12px;
  }
  .fd-grid-md-2,
  .fd-grid-md-3 {
    grid-template-columns: 1fr;
  }
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : LAYOUTS (applayout, header, sidebar, etc.)
// ═══════════════════════════════════════════════════════════

// ── Applayout ─────────────────────────────────────────────

:host {
  display: block;
  background: var(--colorSurfaceAlt);
  --app-bg: var(--colorSurfaceAlt);
  min-height: 100vh;
  overflow-x: hidden;
  isolation: isolate;
}

.app-layout {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100vw;
  height: auto;
  overflow-x: hidden;
  position: relative;
}

.app-layout__sidebar {
  flex: 0 0 auto;
  position: relative;
  z-index: 200;
}

.app-layout__content {
  flex: 1 1 auto;
  min-height: 100vh;
  min-width: 0;
  overflow-x: hidden;
}

.app-layout__header {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
  width: 100%;
}

.app-layout__main {
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-backdrop {
  display: none;
}

@media (max-width: 768px) {
  app-sidebar {
    --sb-overlay: transparent;
  }
  .app-layout__sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 300;
    transform: translateX(-100%);
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.28s;
    visibility: hidden;
    will-change: transform;
  }
  .app-layout__sidebar--open {
    transform: translateX(0);
    visibility: visible;
  }
  .app-layout__content {
    width: 100%;
    max-width: 100vw;
  }
  .app-layout__header {
    position: sticky;
    top: 0;
    z-index: 200;
  }
  .app-layout__main {
    max-height: calc(100vh - 64px);
  }
  .sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 299;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.28s ease;
  }
  .sidebar-backdrop--visible {
    opacity: 1;
    pointer-events: all;
  }
}

// ── Header ─────────────────────────────────────────────────

:host {
  --h-bg: var(--colorWhite);
  --h-border: rgba(15, 15, 15, 0.07);
  --h-text: var(--colorNeutral900);
  --h-muted: var(--colorGray500);
  --h-hover-bg: var(--colorGray100);
  --h-accent: var(--colorAccentVariant);
  --h-radius: var(--radiusMd);
  --header-h: 64px;
  --transition: var(--transitionBase);
  display: block;
  font-size: var(--fontSizeBase);
}

.header-root {
  height: var(--header-h);
}

.header-topbar {
  height: 100%;
  background: var(--h-bg);
  border-bottom: 1px solid var(--h-border);
  box-shadow: 0 1px 0 rgba(0, 0, 0, .04), 0 3px 10px rgba(0, 0, 0, .03);
}

.header-topbar--row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 20px;
  gap: 12px;
  box-sizing: border-box;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-breadcrumb {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 13px;
}

.breadcrumb-root {
  color: var(--colorNeutral900);
  font-weight: var(--fontWeightBold);
  font-size: 15px;
}

.breadcrumb-sep {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 1 !important;
  color: var(--colorGray300);
}

.breadcrumb-current {
  color: var(--colorNeutral900);
  font-weight: var(--fontWeightSemibold);
}

.header-brand-block {
  display: flex;
  flex-direction: column;
}

.breadcrumb-nomcomplet {
  color: var(--colorGray400);
  font-weight: 500;
  font-size: 13px;
}

.header-divider {
  width: 1px;
  height: 20px;
  background: rgba(15, 15, 15, 0.09);
  margin: 0 2px;
}

.header-action-btn {
  --btn-accent: var(--colorNeutral900);
}

.header-action-btn ::ng-deep .btn {
  background: var(--colorWhite) !important;
  border-color: transparent !important;
  color: var(--colorGray500) !important;
  box-shadow: none !important;
}

.header-action-btn ::ng-deep .btn:hover {
  background: var(--h-hover-bg) !important;
  border-color: rgba(15, 15, 15, 0.08) !important;
  color: var(--colorNeutral700) !important;
  transform: translateY(-1px);
}

.sidebar-toggle-btn {
  display: none;
  --btn-accent: var(--colorNeutral900);
}

.sidebar-toggle-btn ::ng-deep .btn {
  background: var(--colorWhite) !important;
  border-color: rgba(15, 15, 15, 0.09) !important;
  color: var(--colorNeutral900) !important;
  box-shadow: none !important;
}

.sidebar-toggle-btn ::ng-deep .btn:hover {
  background: var(--h-hover-bg) !important;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.07) !important;
}

.sidebar-toggle-btn ::ng-deep .btn:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .sidebar-toggle-btn {
    display: flex;
  }
}

.sidebar-toggle-btn mat-icon {
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  line-height: 1 !important;
  color: var(--colorNeutral700);
}

.sidebar-toggle-btn:hover {
  background: var(--h-hover-bg);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.07);
}

.sidebar-toggle-btn:focus-visible {
  outline: 2px solid var(--h-accent);
  outline-offset: 2px;
}

// ── Sidebar ─────────────────────────────────────────────────

:host {
  --sb-w: 240px;
  --sb-coll: 68px;
  --sb-header-h: 68px;
  --sb-bg: var(--colorWhite);
  --sb-border: rgba(15,23,42,.08);
  --sb-overlay: rgba(15,23,42,.45);
  --sb-text: var(--colorBlack);
  --sb-text-sub: var(--colorTextSecondary);
  --sb-text-muted: var(--colorGray500);
  --sb-icon: var(--colorBlack);
  --sb-icon-sub: var(--colorTextSecondary);
  --sb-hover-bg: var(--colorGray100);
  --sb-hover-text: var(--colorBlack);
  --sb-active-bg: var(--sbActiveBg);
  --sb-active-bar: var(--sbActiveBar);
  --sb-active-icon: var(--sbActiveIcon);
  --sb-active-text: var(--sbActiveText);
  --sb-badge-bg: var(--sbBadgeBg);
  --sb-badge-soft-bg: var(--sbBadgeSoftBg);
  --sb-badge-soft-fg: var(--sbBadgeSoftFg);
  --sb-radius: var(--radiusLg);
  --sb-t: var(--transitionSlow);
  --sb-shadow: var(--shadowSidebar);
  display: block;
  height: 100vh;
}

.sidebar {
  position: relative;
  display: flex;
  flex-direction: column;
  width: var(--sb-w);
  height: 100vh;
  background: var(--sb-bg);
  border-right: 1px solid var(--sb-border);
  box-shadow: var(--sb-shadow);
  transition: width var(--sb-t);
  overflow: hidden;
  will-change: width;
}

.sidebar.collapsed {
  width: var(--sb-coll);
}

.sidebar-brand {
  display: flex;
  align-items: center;
  height: var(--sb-header-h);
  padding: 0 14px;
  border-bottom: 1px solid var(--sb-border);
  flex-shrink: 0;
  overflow: hidden;
  gap: 10px;
}

.logo-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 38px;
  overflow: hidden;
}

.logo-full,
.logo-icon {
  position: absolute;
  transition: opacity var(--sb-t), transform var(--sb-t);
}

.logo-full {
  max-width: calc(var(--sb-w) - 80px);
  height: 32px;
  object-fit: contain;
  opacity: 1;
  transform: translateX(0);
}

.logo-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: var(--radiusMd);
  opacity: 0;
  transform: scale(0.65);
}

.sidebar.collapsed .logo-full {
  opacity: 0;
  transform: translateX(-10px);
  pointer-events: none;
}

.sidebar.collapsed .logo-icon {
  opacity: 1;
  transform: scale(1);
}

.sidebar-toggle-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid var(--sb-border);
  border-radius: var(--radiusMd);
  background: transparent;
  cursor: pointer;
  color: var(--sb-icon);
  flex-shrink: 0;
  transition: background var(--sb-t), color var(--sb-t);
}

.sidebar-toggle-btn:hover {
  background: var(--sb-hover-bg);
  color: var(--sb-active-text);
}

.sidebar.collapsed .sidebar-toggle-btn {
  margin: 0 auto;
}

@media (min-width: 769px) {
  .sidebar-toggle-btn {
    display: flex;
  }
}

.sidebar-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 8px 4px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,.1) transparent;
}

.sidebar-scroll::-webkit-scrollbar {
  width: 4px;
}

.sidebar-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,.1);
  border-radius: var(--radiusXs);
}

.sidebar-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(0,0,0,.18);
}

.sidebar-section-label {
  font-size: 0.65rem;
  font-weight: var(--fontWeightBold);
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--sb-text-muted);
  padding: 14px 14px 4px;
  white-space: nowrap;
  overflow: hidden;
  transition: opacity var(--sb-t);
}

.sidebar.collapsed .sidebar-section-label {
  opacity: 0;
  height: 0;
  padding: 0;
}

.sidebar-nav__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sidebar-nav__item {
  position: relative;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  height: 46px;
  padding: 0 12px;
  border-radius: var(--sb-radius);
  color: var(--sb-text);
  text-decoration: none;
  font-size: 0.845rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  background: transparent;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;
  position: relative;
  transition: background var(--sb-t), color var(--sb-t), transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
}

.sidebar-link:hover {
  background: var(--sb-hover-bg);
  color: var(--sb-hover-text);
}

.sidebar-link:active {
  transform: scale(0.985);
}

.sidebar-link--active {
  background: var(--sb-active-bg) !important;
  color: var(--sb-active-text) !important;
  font-weight: var(--fontWeightSemibold);
}

.sidebar-link--active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 18%;
  bottom: 18%;
  width: 3.5px;
  border-radius: 0 4px 4px 0;
  background: var(--sb-active-bar);
}

.sidebar-link--group-active {
  color: var(--sb-active-text);
  font-weight: var(--fontWeightSemibold);
}

.sidebar-link--open {
  background: var(--sb-hover-bg);
}

.sidebar-link__icon {
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0;
  color: var(--sb-icon);
  transition: color var(--sb-t);
}

.sidebar-link:hover .sidebar-link__icon,
.sidebar-link--open .sidebar-link__icon {
  color: var(--sb-active-icon);
}

.sidebar-link--active .sidebar-link__icon {
  color: var(--sb-active-icon);
}

.sidebar-link--group-active .sidebar-link__icon {
  color: var(--sb-active-icon);
}

.sidebar-link__label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}

.sidebar-chevron {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  flex-shrink: 0;
  color: var(--sb-text-muted);
  transition: transform var(--sb-t), color var(--sb-t);
}

.sidebar-link--open .sidebar-chevron,
.sidebar-link--group-active .sidebar-chevron {
  color: var(--sb-active-icon);
}

.sidebar-link--open .sidebar-chevron {
  transform: rotate(180deg);
}

.sidebar-badge {
  font-size: 0.6rem;
  font-weight: var(--fontWeightBold);
  padding: 2px 7px;
  border-radius: 20px;
  background: var(--sb-badge-bg);
  color: var(--colorWhite);
  flex-shrink: 0;
  line-height: 1.5;
  white-space: nowrap;
}

.sidebar-badge--soft {
  background: var(--sb-badge-soft-bg);
  color: var(--sb-badge-soft-fg);
}

@media (min-width: 769px) {
  .sidebar.collapsed .sidebar-link {
    justify-content: center;
    padding: 0;
  }
  .sidebar.collapsed .sidebar-link__label,
  .sidebar.collapsed .sidebar-chevron,
  .sidebar.collapsed .sidebar-badge {
    display: none;
  }
  .sidebar.collapsed .sidebar-nav__item:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    left: calc(var(--sb-coll) + 10px);
    top: 50%;
    transform: translateY(-50%);
    background: var(--colorNeutral800);
    color: var(--colorWhite);
    font-size: 0.78rem;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: var(--radiusMd);
    white-space: nowrap;
    pointer-events: none;
    z-index: 999;
    box-shadow: 0 4px 16px rgba(0,0,0,.18);
    animation: tooltipIn .12s ease;
  }
  @keyframes tooltipIn {
    from { opacity: 0; transform: translateY(-50%) translateX(-4px); }
    to { opacity: 1; transform: translateY(-50%) translateX(0); }
  }
}

.sidebar-submenu {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.2s ease;
}

.sidebar-submenu--open {
  max-height: 600px;
  opacity: 1;
}

.sidebar-submenu__list {
  list-style: none;
  padding: 3px 0 4px 14px;
  margin: 0 0 2px 20px;
  border-left: 2px solid var(--sb-border);
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.sidebar-submenu--nested .sidebar-submenu__list {
  margin-left: 12px;
}

.sidebar-sublink {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border-radius: var(--sb-radius);
  color: var(--sb-text-sub);
  font-size: 0.82rem;
  font-weight: 400;
  text-decoration: none;
  background: transparent;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;
  transition: background var(--sb-t), color var(--sb-t), transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
}

.sidebar-sublink:hover {
  background: var(--sb-hover-bg);
  color: var(--colorBlack);
}

.sidebar-sublink:active {
  transform: scale(0.985);
}

.sidebar-sublink--active {
  background: var(--sb-active-bg) !important;
  color: var(--sb-active-text) !important;
  font-weight: var(--fontWeightSemibold);
}

.sidebar-sublink--group-active {
  color: var(--sb-active-text);
  font-weight: 500;
}

.sidebar-sublink--open {
  background: var(--sb-hover-bg);
}

.sidebar-sublink--deep {
  padding-left: 8px;
  font-size: 0.8rem;
}

.sidebar-sublink__icon {
  font-size: 17px !important;
  width: 17px !important;
  height: 17px !important;
  flex-shrink: 0;
  color: var(--sb-icon-sub);
  transition: color var(--sb-t);
}

.sidebar-sublink:hover .sidebar-sublink__icon,
.sidebar-sublink--active .sidebar-sublink__icon {
  color: var(--sb-active-icon);
}

.sidebar-sublink__label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-chevron--sm {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
}

.sidebar-footer {
  flex-shrink: 0;
  padding: 8px 8px 10px;
  border-top: 1px solid var(--sb-border);
  position: relative;
}

.footer-dropdown {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 8px;
  right: 8px;
  background: var(--colorWhite);
  border: 1px solid var(--sb-border);
  border-radius: var(--sb-radius);
  box-shadow: 0 -6px 24px rgba(0,0,0,.10), var(--shadowSm);
  overflow: hidden;
  z-index: 300;
  max-height: 0;
  opacity: 0;
  pointer-events: none;
  transform: translateY(6px);
  transition: max-height 0.22s cubic-bezier(0.4,0,0.2,1), opacity 0.18s ease, transform 0.18s ease;
}

.footer-dropdown--open {
  max-height: 320px;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.footer-dropdown__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 44px;
  padding: 0 14px;
  color: var(--sb-text);
  font-size: 0.845rem;
  font-weight: 500;
  text-decoration: none;
  background: transparent;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;
  transition: background var(--sb-t), color var(--sb-t);
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
}

.footer-dropdown__item mat-icon {
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0;
  color: var(--sb-icon);
  transition: color var(--sb-t);
}

.footer-dropdown__item:hover {
  background: var(--sb-hover-bg);
  color: var(--sb-hover-text);
}

.footer-dropdown__item:hover mat-icon {
  color: var(--sb-active-icon);
}

.footer-dropdown__item--active {
  background: var(--sb-active-bg);
  color: var(--sb-active-text);
  font-weight: var(--fontWeightSemibold);
}

.footer-dropdown__item--active mat-icon {
  color: var(--sb-active-icon);
}

.footer-dropdown__item--logout {
  color: var(--colorDanger);
}

.footer-dropdown__item--logout mat-icon {
  color: var(--colorDanger);
}

.footer-dropdown__item--logout:hover {
  background: var(--colorDangerSurface);
  color: var(--colorDangerDark);
}

.footer-dropdown__item--logout:hover mat-icon {
  color: var(--colorDangerDark);
}

.footer-dropdown__label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer-dropdown__divider {
  height: 1px;
  background: var(--sb-border);
  margin: 4px 12px;
}

.footer-user-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 48px;
  padding: 0 10px;
  border-radius: var(--sb-radius);
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--sb-text);
  box-sizing: border-box;
  text-align: left;
  transition: background var(--sb-t), color var(--sb-t);
  -webkit-tap-highlight-color: transparent;
}

.footer-user-btn:hover {
  background: var(--sb-hover-bg);
}

.footer-user-btn--open {
  background: var(--sb-active-bg);
  color: var(--sb-active-text);
}

.footer-user-btn__avatar {
  font-size: 28px !important;
  width: 28px !important;
  height: 28px !important;
  flex-shrink: 0;
  color: var(--sb-icon);
  transition: color var(--sb-t);
}

.footer-user-btn--open .footer-user-btn__avatar,
.footer-user-btn:hover .footer-user-btn__avatar {
  color: var(--sb-active-icon);
}

.footer-user-btn__info {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 1px;
}

.footer-user-btn__name {
  font-size: 0.845rem;
  font-weight: var(--fontWeightSemibold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.footer-user-btn__role {
  font-size: 0.72rem;
  color: var(--sb-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.footer-user-btn__chevron {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  flex-shrink: 0;
  color: var(--sb-text-muted);
  transition: transform var(--sb-t), color var(--sb-t);
}

.footer-user-btn--open .footer-user-btn__chevron {
  color: var(--sb-active-icon);
}

.footer-user-btn__chevron {
  transform: rotate(180deg);
}

.footer-user-btn__chevron--up {
  transform: rotate(0deg);
}

@media (min-width: 769px) {
  .sidebar.collapsed .footer-user-btn {
    justify-content: center;
    padding: 0;
  }
  .sidebar.collapsed .footer-user-btn__info,
  .sidebar.collapsed .footer-user-btn__chevron {
    display: none;
  }
  .sidebar.collapsed .sidebar-footer:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    left: calc(var(--sb-coll) + 10px);
    bottom: 14px;
    background: var(--colorNeutral800);
    color: var(--colorWhite);
    font-size: 0.78rem;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: var(--radiusMd);
    white-space: nowrap;
    pointer-events: none;
    z-index: 999;
    box-shadow: 0 4px 16px rgba(0,0,0,.18);
    animation: tooltipIn .12s ease;
  }
}

.sidebar-link:focus-visible,
.sidebar-sublink:focus-visible,
.footer-user-btn:focus-visible,
.footer-dropdown__item:focus-visible,
.sidebar-toggle-btn:focus-visible {
  outline: 2px solid var(--sb-active-bar);
  outline-offset: 2px;
}

// ── Onglet Layout ──────────────────────────────────────────

:host {
  --font-size: var(--fontSizeBase);
}

.onglet-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.onglet-header {
  flex-shrink: 0;
  padding: 24px 24px 0;
  background: var(--colorWhite);
}

.onglet-title {
  font-weight: var(--fontWeightBold);
  color: var(--colorNeutral900);
  letter-spacing: -0.3px;
  margin: 0 0 20px 0;
}

.onglet-nav-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
}

.onglet-nav-wrapper::-webkit-scrollbar {
  display: none;
}

nav.onglet-nav {
  display: inline-flex;
  gap: 2px;
  align-items: flex-end;
  padding: 0;
  margin: 0;
  min-width: 100%;
  border-bottom: 2px solid var(--colorGray200);
  position: relative;
}

.onglet-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  font-size: var(--font-size);
  font-weight: 500;
  color: var(--colorTextPrimary);
  text-decoration: none;
  white-space: nowrap;
  border-radius: var(--radiusMd) var(--radiusMd) 0 0;
  border: 1px solid transparent;
  border-bottom: none;
  background: transparent;
  cursor: pointer;
  transition: color var(--transitionBase), background var(--transitionBase), border-color var(--transitionBase);
}

.onglet-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: var(--colorAccentVariant);
  transform: scaleX(0);
  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.onglet-link:hover {
  color: var(--colorAccentVariant);
  background: #fffefe;
}

.onglet-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  font-size: var(--font-size);
  font-weight: var(--fontWeightSemibold);
  border-radius: 99px;
  background: var(--colorGray200);
  color: var(--colorGray500);
  transition: background var(--transitionBase), color var(--transitionBase);
}

.onglet-link.onglet-active {
  color: var(--colorAccentVariantDark);
  font-weight: var(--fontWeightSemibold);
  background: var(--colorAccentSurface);
  border-color: var(--colorGray200) var(--colorGray200) transparent;
}

.onglet-link.onglet-active::after {
  transform: scaleX(1);
}

.onglet-link.onglet-active .onglet-badge {
  background: var(--colorAccentTealLight);
  color: var(--colorAccentVariantDark);
}

.onglet-link:focus-visible {
  outline: 2px solid var(--colorAccentVariant);
  outline-offset: -2px;
  border-radius: var(--radiusMd) var(--radiusMd) 0 0;
}

.onglet-content {
  flex: 1;
  overflow: auto;
  background: var(--colorWhite);
  border: 1px solid var(--colorGray200);
  border-top: none;
  border-radius: 0 0 var(--radiusXl) var(--radiusXl);
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : MODAL (modal.component.css)
// ═══════════════════════════════════════════════════════════

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(11, 24, 50, 0.48);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
  animation: overlay-in 0.16s ease;
}

@keyframes overlay-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-panel {
  background: var(--colorWhite);
  border-radius: var(--radius3Xl);
  box-shadow: var(--shadow2Xl);
  width: 100%;
  max-width: 580px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 64px);
  overflow: hidden;
  animation: panel-in 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes panel-in {
  from { opacity: 0; transform: translateY(16px) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--colorBorderDivider);
  flex-shrink: 0;
  background: var(--colorWhite);
}

.modal-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.modal-header__icon {
  width: 36px;
  height: 36px;
  border-radius: var(--radiusMd);
  background: linear-gradient(135deg, var(--colorPrimarySurface) 0%, var(--colorPrimaryLight2) 100%);
  border: 1px solid var(--colorPrimary200);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modal-header__icon .material-icons {
  font-size: 18px;
  color: var(--colorPrimary600);
}

.modal-title {
  margin: 0;
  font-family: var(--fontFamilyUi);
  font-size: 15px;
  font-weight: var(--fontWeightBold);
  color: var(--colorNeutral950);
  letter-spacing: -0.2px;
  line-height: 1.3;
}

.modal-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--colorTextLight);
  font-weight: 400;
  line-height: 1.4;
}

.modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 24px;
  scrollbar-width: thin;
  scrollbar-color: #e3e8f0 transparent;
}

.modal-body::-webkit-scrollbar {
  width: 5px;
}

.modal-body::-webkit-scrollbar-track {
  background: transparent;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #e3e8f0;
  border-radius: var(--radiusXs);
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #c8d0df;
}

.modal-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--colorBorderDivider);
  background: var(--colorWhite);
  box-shadow: 0 -4px 12px rgba(11, 24, 50, 0.04);
}

.modal-footer:empty {
  display: none;
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : PAGINATOR (paginator.css)
// ═══════════════════════════════════════════════════════════

.paginator-root {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: var(--colorAccentSurface);
  border-radius: var(--radiusMd);
  padding: 0.5rem 0.75rem;
  margin-top: 1rem;
}

.paginator-info {
  font-size: 0.875rem;
  color: var(--colorNeutral700);
}

.paginator-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-btn {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radiusFull);
  border: 1px solid var(--colorNeutral800);
  background: transparent;
  cursor: pointer;
}

.nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn {
  width: 36px;
  height: 36px;
  border-radius: var(--radiusFull);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  border: 1px solid var(--colorBorderInput);
  background: transparent;
  cursor: pointer;
}

.page-btn--active {
  background: var(--colorNeutral800);
  color: var(--colorWhite);
  border-color: transparent;
  font-weight: var(--fontWeightSemibold);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : STEPPER (stepper.css)
// ═══════════════════════════════════════════════════════════

.stepper-root {
  width: 100%;
}

.steps-wrapper {
  position: relative;
  display: flex;
  gap: 12px;
  align-items: stretch;
  background: transparent;
  padding: 8px 4px 18px 4px;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.steps-wrapper::-webkit-scrollbar {
  height: 0;
}

.step {
  flex: 1 1 0;
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: default;
  padding: 8px 6px;
  border-radius: var(--radiusSm);
  transition: color 180ms ease, background-color 180ms ease, opacity 180ms ease;
  user-select: none;
  border-bottom: 2px solid transparent;
}

.step.prev {
  opacity: 0.85;
}

.step.next {
  opacity: 0.9;
}

.step.active {
  opacity: 1;
  border-bottom-color: var(--btnSelectedBg);
  font-weight: var(--fontWeightBold);
}

.step-marker {
  display: flex;
  align-items: center;
}

.circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--colorWhite);
  color: var(--colorBlack);
  border: 2px solid rgba(0, 0, 0, 0.08);
  font-weight: var(--fontWeightSemibold);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.step.active .circle {
  background: var(--btnSelectedBg);
  color: var(--btnSelectedColor);
}

.step.completed .circle {
  background: var(--btnSelectedBg);
  color: var(--btnSelectedColor);
}

.step-title {
  color: var(--colorBlack);
  font-size: 0.95rem;
  flex: 1;
  padding: 4px 6px;
}

.indicator {
  position: absolute;
  bottom: 6px;
  left: 0;
  height: 4px;
  background: linear-gradient(90deg, rgba(6, 182, 172, 0.9), rgba(59, 130, 246, 0.9));
  border-radius: var(--radiusXs);
  transition: transform 300ms cubic-bezier(.2, .9, .2, 1), width 200ms ease;
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : TABLE (table.css, table.component.scss)
// ═══════════════════════════════════════════════════════════

.table-root {
  padding: 1rem;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.01));
  border-radius: var(--radiusXl);
  box-shadow: 0 6px 20px rgba(2, 6, 23, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.table-root .overflow-x-auto {
  background: transparent;
}

.table-root table tr:hover td {
  background: rgba(255, 255, 255, 0.02);
}

// ── UiTableComponent ──────────────────────────────────────

:host {
  display: block;
}

.table-root {
  background: var(--colorSurface);
  border-radius: var(--radius2Xl);
  border: 1.5px solid var(--colorBorder);
  box-shadow: var(--shadowCard);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.overflow-x-auto {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1;
  scrollbar-width: thin;
  scrollbar-color: var(--colorBorder) transparent;
}

.overflow-x-auto::-webkit-scrollbar {
  height: 5px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: transparent;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background: var(--colorBorderStrong);
  border-radius: 99px;
}

.ui-table {
  border-collapse: collapse;
  width: 100%;
  font-family: var(--fontFamily);
  font-size: 0.9rem;
  color: var(--colorTextPrimary);
}

.ui-table-thead-tr {
  color: var(--colorTextPrimary);
  background: var(--colorSurfaceAlt2);
  border-bottom: 2px solid var(--colorBorderStrong);
}

.ui-table-th {
  padding: 13px 16px;
  font-size: 0.75rem;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorTextPrimary);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.055em;
  white-space: nowrap;
}

.ui-table-th:first-child {
  padding-left: 20px;
}

.ui-table-body-tr {
  border-bottom: 1px solid var(--colorBorder);
  transition: background 0.14s ease;
}

.ui-table-body-tr:last-child {
  border-bottom: none;
}

.ui-table-body-tr:hover {
  background: var(--colorPrimarySoft);
}

.ui-table-body-tr:hover .ui-table-td.actions-cell {
  background: color-mix(in srgb, var(--colorPrimary) 4%, white);
}

.ui-table-body-tr:nth-of-type(even) {
  background-color: var(--colorSurfaceAlt2);
}

.ui-table-body-tr:nth-of-type(even):hover {
  background: var(--colorPrimarySoft);
}

.ui-table-td {
  padding: 12px 16px;
  font-size: 0.87rem;
  color: var(--colorTextPrimary);
  vertical-align: top;
}

.ui-table-td:first-child {
  padding-left: 20px;
  font-weight: 500;
}

.ui-table-empty {
  padding: 56px 16px;
  text-align: center;
  color: var(--colorTextMuted);
  font-size: 0.87rem;
}

.ui-table-empty .empty-icon {
  display: block;
  font-size: 2.2rem;
  margin-bottom: 10px;
  opacity: 0.35;
}

.cell-truncate {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 340px;
}

.cell-text {
  line-height: 1.5;
  word-break: break-word;
}

.btn-see-more {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  border: none;
  background: none;
  padding: 0;
  color: var(--colorPrimary);
  font-family: var(--fontFamily);
  font-size: 0.78rem;
  font-weight: var(--fontWeightSemibold);
  cursor: pointer;
  transition: opacity 0.15s ease;
  align-self: flex-start;
}

.btn-see-more .material-icons {
  font-size: 14px;
}

.btn-see-more:hover {
  opacity: 0.75;
}

.ui-table-th.actions-cell,
.ui-table-td.actions-cell {
  position: sticky;
  right: 0;
  z-index: 10;
  background: var(--colorSurface);
  text-align: right;
  padding-right: 20px;
  min-width: 130px;
  white-space: nowrap;
  vertical-align: middle;
  box-shadow: -6px 0 16px -6px rgba(14, 14, 18, 0.07);
}

.ui-table-thead-tr .actions-cell {
  z-index: 15;
  background: var(--colorSurfaceAlt2);
}

.actions-buttons {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
  align-items: center;
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1.5px solid var(--colorBorder);
  background: var(--colorSurfaceAlt2);
  gap: 16px;
  flex-wrap: wrap;
}

.table-info {
  font-family: var(--fontFamily);
  font-size: 0.8rem;
  color: var(--colorTextMuted);
}

.table-info span {
  font-weight: var(--fontWeightSemibold);
  color: var(--colorTextSecondary);
}

.pagination {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--fontFamily);
  font-size: 0.8rem;
  color: var(--colorTextMuted);
}

.page-size-selector label {
  white-space: nowrap;
}

.page-size-selector select {
  appearance: none;
  background: var(--colorSurface);
  border: 1.5px solid var(--colorBorder);
  border-radius: var(--radiusSm);
  padding: 5px 28px 5px 10px;
  font-family: var(--fontFamily);
  font-size: 0.8rem;
  color: var(--colorTextPrimary);
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M6 9l6 6 6-6' stroke='%238e8ea8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  transition: border-color 0.18s ease;
}

.page-size-selector select:focus {
  outline: none;
  border-color: var(--colorPrimary);
  box-shadow: 0 0 0 3px rgba(91, 79, 255, 0.14);
}

.pagination-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 6px;
  border: 1.5px solid var(--colorBorder);
  border-radius: var(--radiusSm);
  background: var(--colorSurface);
  font-family: var(--fontFamily);
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--colorTextSecondary);
  cursor: pointer;
  transition: all 0.15s ease;
}

.page-btn .material-icons {
  font-size: 18px;
}

.page-btn:hover:not(:disabled) {
  border-color: var(--colorPrimary);
  color: var(--colorPrimary);
  background: var(--colorPrimarySoft);
}

.page-btn:disabled {
  opacity: 0.38;
  cursor: not-allowed;
}

.page-btn--active {
  background: var(--colorPrimary);
  border-color: var(--colorPrimary);
  color: var(--colorWhite);
  font-weight: var(--fontWeightSemibold);
  box-shadow: 0 2px 8px rgba(91, 79, 255, 0.3);
}

.page-btn--active:hover {
  background: color-mix(in srgb, var(--colorPrimary) 88%, black);
  border-color: color-mix(in srgb, var(--colorPrimary) 88%, black);
  color: var(--colorWhite);
}

.page-btn--arrow {
  color: var(--colorTextMuted);
}

.page-ellipsis {
  padding: 0 4px;
  color: var(--colorTextMuted);
  font-size: 0.85rem;
  letter-spacing: 0.05em;
  user-select: none;
}

@media (max-width: 768px) {
  .ui-table-th,
  .ui-table-td {
    padding: 11px 12px;
    font-size: 0.84rem;
  }
  .ui-table-th.actions-cell,
  .ui-table-td.actions-cell {
    padding-right: 14px;
    min-width: 100px;
  }
  .table-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
  }
  .pagination {
    width: 100%;
    justify-content: space-between;
  }
  .cell-truncate {
    max-width: 200px;
  }
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : CONFIRM DIALOG (Confirmdialog.component.scss)
// ═══════════════════════════════════════════════════════════

:host {
  display: contents;
}

.cd-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(5, 10, 25, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: cd-fade-in 0.18s ease;
  padding: 16px;
}

@keyframes cd-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.cd-panel {
  position: relative;
  background: var(--colorWhite);
  border-radius: var(--radius4Xl);
  padding: 36px 32px 28px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  box-shadow: var(--shadow3Xl);
  animation: cd-slide-up 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes cd-slide-up {
  from { transform: translateY(20px) scale(0.95); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

.cd-icon-wrap {
  position: relative;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cd-icon-ring {
  position: absolute;
  border-radius: 50%;
  animation: cd-pulse 2s ease-in-out infinite;
}

.cd-icon-ring--outer {
  inset: 0;
  background: rgba(239, 68, 68, .08);
  animation-delay: 0s;
}

.cd-icon-ring--inner {
  inset: 8px;
  background: rgba(239, 68, 68, .12);
  animation-delay: .3s;
}

.cd-icon-ring--warn {
  animation: cd-pulse-warn 2s ease-in-out infinite;
}

.cd-icon-ring--outer.cd-icon-ring--warn {
  background: rgba(249, 115, 22, .08);
}

.cd-icon-ring--inner.cd-icon-ring--warn {
  background: rgba(249, 115, 22, .13);
}

@keyframes cd-pulse {
  0%, 100% { transform: scale(1); opacity: .7; }
  50% { transform: scale(1.08); opacity: 1; }
}

@keyframes cd-pulse-warn {
  0%, 100% { transform: scale(1); opacity: .7; }
  50% { transform: scale(1.08); opacity: 1; }
}

.cd-icon-circle {
  position: relative;
  z-index: 1;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--colorDanger500) 0%, var(--colorDanger) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(239, 68, 68, .45), 0 1px 3px rgba(239, 68, 68, .3);
}

.cd-icon-circle mat-icon {
  color: var(--colorWhite);
  font-size: 26px !important;
  width: 26px !important;
  height: 26px !important;
  line-height: 26px !important;
}

.cd-icon-circle--warn {
  background: linear-gradient(135deg, var(--colorWarning500) 0%, var(--colorWarning600) 100%);
  box-shadow: 0 4px 14px rgba(249, 115, 22, .40), 0 1px 3px rgba(249, 115, 22, .25);
}

.cd-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  width: 100%;
}

.cd-title {
  font-family: var(--fontFamilyUi);
  font-size: 18px;
  font-weight: var(--fontWeightBold);
  color: var(--colorNeutral950);
  margin: 0;
  letter-spacing: -.3px;
}

.cd-message {
  font-family: var(--fontFamily);
  font-size: 14px;
  color: var(--colorTextBody);
  margin: 0;
  line-height: 1.55;
  max-width: 300px;
}

.cd-message strong {
  color: var(--colorNeutral950);
  font-weight: var(--fontWeightBold);
}

.cd-item-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: rgba(239, 68, 68, .06);
  border: 1px solid rgba(239, 68, 68, .16);
  border-radius: var(--radiusMd);
  font-size: 13px;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorDangerDark);
  max-width: 100%;
  word-break: break-word;
  text-align: left;
  margin-top: 4px;
}

.cd-item-label span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.cd-item-label__icon {
  font-size: 14px !important;
  width: 14px !important;
  height: 14px !important;
  line-height: 14px !important;
  color: var(--colorDanger);
  flex-shrink: 0;
}

.cd-blocked-hint {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 14px;
  background: var(--colorWarningBg);
  border: 1px solid rgba(249, 115, 22, .22);
  border-radius: var(--radiusLg);
  margin-top: 4px;
  text-align: left;
  max-width: 320px;
}

.cd-blocked-hint__icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
  color: var(--colorWarning500);
  flex-shrink: 0;
  margin-top: 1px;
}

.cd-blocked-hint span {
  font-size: 12.5px;
  color: #7c3109;
  line-height: 1.55;
  font-weight: 500;
}

.cd-actions {
  display: flex;
  gap: 10px;
  width: 100%;
}

.cd-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 11px 18px;
  border-radius: var(--radiusLg);
  border: none;
  font-family: var(--fontFamilyUi);
  font-size: 14px;
  font-weight: var(--fontWeightSemibold);
  cursor: pointer;
  transition: all .18s cubic-bezier(.4,0,.2,1);
  white-space: nowrap;
}

.cd-btn mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}

.cd-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
  transform: none !important;
}

.cd-btn--cancel {
  background: var(--colorGray100);
  color: var(--colorGray600);
  border: 1px solid var(--colorGray200);
}

.cd-btn--cancel:hover:not(:disabled) {
  background: var(--colorGray200);
  color: var(--colorNeutral800);
  border-color: var(--colorGray300);
}

.cd-btn--cancel:active:not(:disabled) {
  background: var(--colorGray300);
}

.cd-btn--confirm {
  background: linear-gradient(135deg, var(--colorDanger500) 0%, var(--colorDanger) 100%);
  color: var(--colorWhite);
  box-shadow: 0 4px 14px rgba(220, 38, 38, .35), inset 0 1px 0 rgba(255,255,255,.15);
}

.cd-btn--confirm:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(220, 38, 38, .45), inset 0 1px 0 rgba(255,255,255,.15);
}

.cd-btn--confirm:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(220, 38, 38, .3);
}

.cd-btn--confirm.cd-btn--loading {
  pointer-events: none;
}

.cd-btn--full {
  max-width: 100%;
}

.cd-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,.4);
  border-top-color: var(--colorWhite);
  border-radius: 50%;
  animation: cd-spin .65s linear infinite;
  flex-shrink: 0;
}

.cd-btn--waiting {
  background: linear-gradient(135deg, var(--colorGray400) 0%, var(--colorGray500) 100%) !important;
  box-shadow: none !important;
  cursor: not-allowed;
}

.cd-btn--waiting:hover {
  transform: none !important;
}

.cd-countdown {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  font-size: 12px;
  font-weight: var(--fontWeightExtraBold);
  line-height: 1;
  flex-shrink: 0;
}

@keyframes cd-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 480px) {
  .cd-panel {
    padding: 28px 20px 22px;
    border-radius: var(--radius3Xl);
  }
  .cd-actions {
    flex-direction: column-reverse;
  }
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : LOADER (loader.component.css, loaderIntervantion.component.css)
// ═══════════════════════════════════════════════════════════

.loader-spinner {
  width: var(--loader-size, 24px);
  height: var(--loader-size, 24px);
  border: var(--spinner-border-size) solid var(--spinner-base-color, rgba(255, 255, 255, 0.3));
  border-top-color: var(--spinner-top-color, var(--colorWhite));
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

// ── Loader Intervention ────────────────────────────────────

:host {
  display: block;
  overflow: hidden;
}

:host:empty {
  display: none;
}

@keyframes ld2-shimmer {
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
}

.ld2-bone {
  background: linear-gradient(90deg, #e8ecf0 25%, #f4f6f8 50%, #e8ecf0 75%);
  background-size: 600px 100%;
  animation: ld2-shimmer 1.5s infinite linear;
  border-radius: var(--radiusSm);
  flex-shrink: 0;
  will-change: background-position;
  backface-visibility: hidden;
  transform: translateZ(0);
}

.ld2-wrapper {
  border-radius: var(--radiusLg);
  border: 1px solid rgba(15, 28, 45, 0.05);
  background: var(--colorWhite);
  contain: layout;
  isolation: isolate;
  position: relative;
}

.ld2-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 130px 130px 180px;
  padding: 14px 14px;
  background: linear-gradient(180deg, #fafbff, #f3f6fc);
  border-bottom: 2px solid #e8ecf0;
  align-items: center;
  gap: 0;
}

.ld2-header__col {
  display: flex;
  align-items: center;
  padding: 4px 12px;
}

.ld2-header__col--date,
.ld2-header__col--actions {
  justify-content: center;
}

.ld2-bone--header {
  height: 14px;
  opacity: 0.7;
}

.ld2-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 130px 130px 180px;
  align-items: center;
  min-height: 56px;
  border-bottom: 1px solid rgba(15, 28, 45, 0.04);
  padding-right: 14px;
  transition: background .1s;
}

.ld2-row--alt {
  background: rgba(245, 247, 255, 0.45);
}

.ld2-row__col {
  padding: 10px 6px;
  display: flex;
  align-items: center;
  min-width: 0;
}

.ld2-row__col--main {
  gap: 10px;
  padding-left: 14px;
}

.ld2-row__col--date {
  justify-content: center;
}

.ld2-row__col--actions {
  justify-content: center;
  gap: 6px;
}

.ld2-text-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.ld2-bone--tag {
  height: 16px;
  border-radius: var(--radiusXs);
  opacity: 0.6;
  max-width: 100px;
}

.ld2-bone--title {
  height: 16px;
  border-radius: var(--radiusSm);
}

.ld2-bone--title-2 {
  height: 14px;
  opacity: 0.5;
}

.ld2-bone--icon {
  width: 24px;
  height: 24px;
  border-radius: var(--radiusSm);
  flex-shrink: 0;
  opacity: 0.45;
}

.ld2-spacer {
  width: 24px;
  flex-shrink: 0;
}

.ld2-indent {
  flex-shrink: 0;
  height: 1px;
}

.ld2-date-card {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: var(--radiusMd);
  background: #f0f4f8;
  border: 1.5px solid var(--colorBorder);
  min-width: 80px;
}

.ld2-bone--date-icon {
  width: 13px;
  height: 13px;
  border-radius: var(--radiusXs);
  opacity: 0.5;
}

.ld2-bone--date-value {
  width: 52px;
  height: 18px;
  border-radius: var(--radiusXs);
}

.ld2-bone--date-label {
  width: 30px;
  height: 10px;
  border-radius: var(--radiusXs);
  opacity: 0.45;
}

.ld2-bone--action-btn {
  width: 30px;
  height: 30px;
  border-radius: var(--radiusSm);
  opacity: 0.5;
}

.ld2-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 880px) {
  .ld2-header,
  .ld2-row {
    grid-template-columns: minmax(0, 1fr) 110px 110px 160px;
  }
}

@media (max-width: 640px) {
  .ld2-header,
  .ld2-row {
    grid-template-columns: 1fr;
  }
  .ld2-row__col--date,
  .ld2-row__col--actions {
    display: none;
  }
  .ld2-header__col--date,
  .ld2-header__col--actions {
    display: none;
  }
}

// ═══════════════════════════════════════════════════════════
// COMPOSANT : SEARCH FILTER (Searchfilter.component.scss)
// ═══════════════════════════════════════════════════════════

:host {
  display: block;
  font-size: var(--fontSizeBase);
  height: 100%;
  min-width: 0;
  overflow: hidden;
}

.sf-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--colorWhite);
  border-radius: 0;
  overflow-x: hidden;
  overflow-y: visible;
  min-width: 0;
  box-sizing: border-box;
}

.sf-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 24px 28px 20px;
  border-bottom: 1px solid var(--colorBorderDivider);
  flex-shrink: 0;
  min-width: 0;
  flex-wrap: wrap;
}

.sf-header__icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radiusLg);
  background: linear-gradient(135deg, var(--colorViolet) 0%, var(--colorVioletVariant) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.25);
}

.sf-header__icon mat-icon {
  color: var(--colorWhite);
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.sf-header__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.sf-header__title {
  font-family: var(--fontFamilyUi);
  font-size: 15px;
  font-weight: var(--fontWeightBold);
  color: var(--colorTextPrimary);
  letter-spacing: -0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sf-header__sub {
  font-size: 12px;
  color: var(--colorTextLight);
  font-weight: 400;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sf-header__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  font-family: var(--fontFamilyUi);
  font-size: 11px;
  font-weight: var(--fontWeightBold);
  flex-shrink: 0;
  transition: background var(--transitionBase), color var(--transitionBase), box-shadow var(--transitionBase);
  background: #eef0f5;
  color: var(--colorBlack);
  box-shadow: none;
}

.sf-header__badge--has-value {
  background: linear-gradient(135deg, var(--colorViolet), var(--colorVioletVariant));
  color: var(--colorWhite);
  box-shadow: 0 2px 6px rgba(124, 58, 237, 0.32);
  animation: sf-pop 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes sf-pop {
  from { transform: scale(0.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.sf-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px 28px;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.sf-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.sf-field--date {
  flex: 1;
  min-width: 0;
}

.sf-field__label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorBlack);
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.sf-field__label--small {
  font-size: 11px;
  text-transform: none;
  letter-spacing: 0;
  color: var(--colorBlack);
}

.sf-field__label-icon {
  font-size: 14px !important;
  width: 14px !important;
  height: 14px !important;
  line-height: 14px !important;
  color: var(--colorBlack);
  flex-shrink: 0;
}

.sf-field__input-wrap {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
}

.sf-search-icon {
  position: absolute;
  left: 12px;
  z-index: 1;
  pointer-events: none;
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
  color: var(--colorBlack);
  transition: color var(--transitionBase);
}

.sf-date-icon {
  position: absolute;
  left: 11px;
  z-index: 1;
  pointer-events: none;
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
  color: var(--colorBlack);
  transition: color var(--transitionBase);
}

.sf-field__input-wrap--search:focus-within .sf-search-icon,
.sf-field__input-wrap--date:focus-within .sf-date-icon {
  color: var(--colorBlack);
}

.sf-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 36px 10px 40px;
  font-family: var(--fontFamily);
  font-size: 13.5px;
  color: var(--colorBlack);
  background: var(--colorSurfaceInput);
  border: 1.5px solid var(--colorBlack);
  border-radius: var(--radiusLg);
  outline: none;
  transition: border-color var(--transitionBase), box-shadow var(--transitionBase), background var(--transitionBase);
  min-width: 0;
}

.sf-input::placeholder {
  color: var(--colorBlack);
}

.sf-input:hover {
  border-color: #c8d0df;
  background: var(--colorWhite);
}

.sf-input:focus {
  border-color: var(--colorViolet);
  background: var(--colorWhite);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.14);
}

.sf-input--date {
  cursor: pointer;
  font-size: 13px;
  padding-right: 32px;
  color-scheme: light;
}

.sf-input--date::-webkit-calendar-picker-indicator {
  opacity: 0;
  position: absolute;
  right: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 2;
}

.sf-input--date::-moz-calendar-picker-indicator {
  opacity: 0;
}

.sf-clear-btn {
  position: absolute;
  right: 8px;
  z-index: 3;
  background: none;
  border: none;
  padding: 3px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: #c2c9d6;
  border-radius: var(--radiusSm);
  transition: color 0.15s, background 0.15s;
  flex-shrink: 0;
}

.sf-clear-btn mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
}

.sf-clear-btn:hover {
  color: var(--colorDanger500);
  background: rgba(239, 68, 68, 0.08);
}

.sf-clear-btn--inline {
  right: 6px;
}

.sf-period {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.sf-period__label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: var(--fontWeightSemibold);
  color: var(--colorTextLight);
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.sf-period__row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  min-width: 0;
  flex-wrap: wrap;
}

.sf-period__arrow {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  color: var(--colorBlack);
  flex-shrink: 0;
}

.sf-period__arrow mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
}

.sf-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 28px 20px;
  border-top: 1px solid var(--colorBorderDivider);
  flex-shrink: 0;
  flex-wrap: wrap;
  min-height: 64px;
  min-width: 0;
  box-sizing: border-box;
}

.sf-chips {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  flex: 1;
  min-height: 28px;
  min-width: 0;
}

.sf-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 6px 4px 10px;
  border-radius: 20px;
  font-family: var(--fontFamily);
  font-size: 12px;
  font-weight: var(--fontWeightSemibold);
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  animation: sf-pop 0.18s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.sf-chip--search {
  background: rgba(124, 58, 237, 0.08);
  border: 1px solid rgba(124, 58, 237, 0.18);
  color: var(--colorVioletVariant);
}

.sf-chip--date {
  background: rgba(11, 102, 209, 0.07);
  border: 1px solid rgba(11, 102, 209, 0.16);
  color: var(--colorPrimary600);
}

.sf-chip__icon {
  font-size: 12px !important;
  width: 12px !important;
  height: 12px !important;
  line-height: 12px !important;
  opacity: 0.75;
  flex-shrink: 0;
}

.sf-chip__label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.sf-chip__remove {
  background: none;
  border: none;
  padding: 1px;
  margin-left: 2px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: var(--radiusXs);
  color: currentColor;
  opacity: 0.6;
  flex-shrink: 0;
  transition: opacity 0.12s, background 0.12s;
}

.sf-chip__remove mat-icon {
  font-size: 11px !important;
  width: 11px !important;
  height: 11px !important;
  line-height: 11px !important;
}

.sf-chip__remove:hover {
  opacity: 1;
  background: rgba(0,0,0,0.07);
}

.sf-chips__empty {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--fontFamily);
  font-size: 12px;
  font-weight: 400;
  color: #2e2e2e;
  font-style: italic;
  user-select: none;
}

.sf-chips__empty mat-icon {
  font-size: 15px !important;
  width: 15px !important;
  height: 15px !important;
  line-height: 15px !important;
  color: #2e2e2e;
}

.sf-reset-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  color: var(--colorTextLight);
  border: 1px solid var(--colorBorder);
  border-radius: var(--radiusMd);
  padding: 5px 12px;
  font-family: var(--fontFamilyUi);
  font-size: 12px;
  font-weight: var(--fontWeightSemibold);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: color var(--transitionBase), border-color var(--transitionBase), background var(--transitionBase);
  animation: sf-pop 0.18s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.sf-reset-btn mat-icon {
  font-size: 15px !important;
  width: 15px !important;
  height: 15px !important;
  line-height: 15px !important;
  color: inherit;
}

.sf-reset-btn:hover {
  color: var(--colorDanger500);
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.04);
}

.sf-reset-btn:active {
  background: rgba(239, 68, 68, 0.08);
}

@media (max-width: 960px) {
  .sf-wrapper {
    border-radius: 0;
    overflow-y: visible;
  }
  .sf-footer {
    min-height: auto;
  }
}

@media (max-width: 720px) {
  .sf-header {
    padding: 18px 20px 16px;
    gap: 10px;
  }
  .sf-body {
    padding: 16px 20px;
    gap: 14px;
  }
  .sf-footer {
    padding: 12px 20px 16px;
    min-height: auto;
  }
  .sf-period__arrow {
    display: none;
  }
  .sf-period__row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .sf-field--date {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .sf-header {
    padding: 14px 16px 12px;
    gap: 8px;
  }
  .sf-header__icon {
    width: 34px;
    height: 34px;
  }
  .sf-header__icon mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .sf-header__title {
    font-size: 14px;
  }
  .sf-header__sub {
    display: none;
  }
  .sf-body {
    padding: 14px 16px;
    gap: 12px;
  }
  .sf-footer {
    padding: 10px 16px 14px;
  }
  .sf-input {
    font-size: 13px;
    padding: 9px 32px 9px 38px;
  }
  .sf-chip {
    max-width: 140px;
  }
}
`;